/* global __CONFIG__ */
import {
  generateURL,
  generateURLWithoutLocale,
} from '@coconut/utils/navigation';
import { getAppLocale } from '@coconut/services/redux/app';

const action = (actionName) => `NAV:${actionName}`;

export const types = {
  HOME: action('HOME'),
  PREVIOUS: action('PREVIOUS'),
  UPLOAD_IMAGE: action('UPLOAD_IMAGE'),
  LANDING_PAGE: action('LANDING_PAGE'),
  OPEN_EXTERNAL_URL: action('OPEN_EXTERNAL_URL'),
  CHAT_ROOM: action('CHAT_ROOM'),
  SIGNUP: action('SIGNUP'),
  TUTOR_HOME: action('TUTOR_HOME'),
  TUTOR_CHATROOM: action('TUTOR_CHATROOM'),
  ACADEMY_PAGE: action('ACADEMY_PAGE'),
};

export const home = () => ({
  type: types.HOME,
});

export const chatRoom = (questionId) => ({
  type: types.CHAT_ROOM,
  payload: {
    questionId,
  },
});

export const previous = () => ({
  type: types.PREVIOUS,
});

export const uploadImage = () => ({
  type: types.UPLOAD_IMAGE,
});

export const openExternalUrl = (url) => ({
  type: types.OPEN_EXTERNAL_URL,
  payload: {
    url,
  },
});

export const goToLandingPage = (path) => ({
  type: types.LANDING_PAGE,
  path,
});

export const goToSignup = () => ({
  type: types.SIGNUP,
});

export const goToTutorHome = () => ({
  type: types.TUTOR_HOME,
});

export const goToAcademyPage = (path) => ({
  type: types.ACADEMY_PAGE,
  path,
});

export const generateOfficialSiteURL = (state) => {
  const locale = getAppLocale(state);
  return (path, params) =>
    generateURL({
      path,
      baseUrl: __CONFIG__.SNAPASK_LANDING_ROOT_PATH,
      params,
      locale,
    });
};

export const generateAcademyURL = (state) => {
  const locale = getAppLocale(state);

  return (path, params) =>
    generateURL({
      path,
      baseUrl: __CONFIG__.ACADEMY_SITE_ENDPOINT,
      params,
      locale,
    });
};

export const generateQuestionAskURL = () => {
  return (path, params) =>
    generateURLWithoutLocale({
      path,
      baseUrl: __CONFIG__.SNAPASK_QA_ROOT_PATH,
      params,
    });
};



// WEBPACK FOOTER //
// ./src/services/redux/navigation.js